let DISABLE_DRAGGING = true;
import PropTypes from "prop-types";
import React from "react";
import Constants from "expo-constants";
import {
  View,
  ScrollView,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Dimensions,
  StyleSheet,
  AppState,
  RefreshControl,
} from "react-native";
// import { ScrollView as GestureHandlerScrollView } from "react-native-gesture-handler";
import ENV from "app/utils/ENV";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import chapterActions from "app/utils/chapterActions";
import alertActions from "app/utils/alertActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import chapterHelpers from "app/utils/chapterHelpers";
import momentHelpers from "app/utils/momentHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import haptics from "app/utils/haptics";
import * as RootNavigation from "app/utils/RootNavigation.js";
import * as ScreenOrientation from "expo-screen-orientation";

import { HeaderHeightContext } from "@react-navigation/elements";

import {
  // styleSheet,
  //   colors,
  sizes,
  //   mobileIncrease,
  //   WIDTH,
} from "app/utils/styleSheet";
import {
  Feather,
  AntDesign,
  Ionicons,
  FontAwesome,
  MaterialCommunityIcons,
  FontAwesome5,
  Entypo,
  Foundation,
} from "@expo/vector-icons";

import ChapterForm from "app/components/chapter/ChapterForm";
import RecursiveChapter from "app/components/chapter/RecursiveChapter";
import BadgeRow from "app/components/chapter/BadgeRow";
import MomentList from "app/components/chapter/MomentList";
import MomentBullet from "app/components/chapter/MomentBullet";
import Icon from "app/components/Icon";
import TextInput from "app/components/TextInput";
import Hoverable from "app/components/Hoverable";
import HoverableTooltip from "app/components/HoverableTooltip";
import ScratchPad from "app/components/ScratchPad";
import Value from "app/components/Value";

import Draggable from "app/components/Draggable";
import DatePicker from "app/components/DatePicker";
import TarotCard from "app/components/TarotCard";
import tarotHelpers from "app/utils/tarotHelpers";
import store from "app/redux/store";
import storageActions from "app/utils/storageActions";

let WIDTH = Dimensions.get("window").width;

import { StyleContext } from "app/contexts/Style";

export default class Chapter extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    backgroundColor: PropTypes.string,
  };

  static defaultProps = {
    levelsDeep: 1,
  };

  constructor(props, context) {
    super(props, context);
    let { chapter, isToday } = this.updateChapter(props.chapter);

    let chapterWidth = this.chapterWidth(props, context);

    let globalDetailsMode = store.getState().preferences.detailsMode;

    const chapterColor = chapterHelpers.getColor(
      chapter,
      context.colors,
      context.colorScheme,
    );

    this.headerButtonRefs = [];

    this.state = {
      loading: false,
      fetching: false,
      // editing: props.composer || false,
      composer: props.composer || false,
      editing: false,
      chapter,
      isToday,
      atemporal: chapterHelpers.atemporal(chapter) && !props.composer,
      expanded: props.expanded || false,
      zoomedChapterIds: [],
      focusedChapterId: null,
      // zoomedChapterId: props.chapter?.sub_chapters?.find((c) => c.current)?.id,
      hiddenIds: chapter.current && chapter.range > 7 ? ["non_current"] : [],
      hiddenIds: [],
      expandedIds: ["current"],
      level: props.level || 0,
      autoCreate: props.autoCreate,
      // preventAutoFocus: props.preventAutoFocus,
      chapterWidth,
      expandScratchPad: false,
      showScratchPadActions: false,
      expandSuggestions: false,
      mountainView: false,
      expandingHeightAnim: new Animated.Value(props.expanded ? 1 : 0),
      appState: AppState.currentState,
      details: "all",
      details: globalDetailsMode || "titles",
      globalDetailsMode,
      colorAnim: new Animated.Value(1),
      // prevChapterColor: this.context.colors.empty,
      prevChapterColor: chapterColor,
      chapterColor,
      hideSuggestionsFromBelow: true,
      hideSuggestionsFromAbove: true,
      hideRolloverSuggestions: true,
      // listView: true,
      listView: false,
      // testing suggestions
      // expandSuggestions: true,
      hideSuggestionsFromBelow: false,
      hideSuggestionsFromAbove: false,
      hideRolloverSuggestions: false,
      extraSubChapters: [],
      fetchingExtraSubChapters: false,
      selectedTarotMoment: null,
      prevChapterTarotMoment: null,
      prevChapterData: null,
    };
  }

  async componentDidMount() {
    let { expanded } = this.props;
    if (expanded) {
      this.fetchChapter({ autoSelectTarot: true });
    }
    this.unsubscribeFocus = this.props.navigation?.addListener("focus", () => {
      console.log("nav focus subscribe");
      this.subscribe();
    });
    this.unsubscribeBlur = this.props.navigation?.addListener(
      "blur",
      this.unsubscribe,
    );
    this.subscribe();

    this.appStateListener = AppState.addEventListener(
      "change",
      this._handleAppStateChange,
    );

    ScreenOrientation.addOrientationChangeListener(() => {
      console.log("orientation changed!");
      this.updateChapterWidth();
      setTimeout(() => {
        this.updateChapterWidth();
      }, 1000);
    });
  }

  chapterWidth = (props = null, context = null) => {
    props = props || this.props;
    context = context || this.context;
    WIDTH = Dimensions.get("window").width;

    // this.CHAPTER_WIDTH = !ENV.WEB
    //   ? WIDTH - context.sizes.large
    //   : Math.min(300, WIDTH * 1);
    this.CHAPTER_WIDTH = !ENV.WEB ? WIDTH : Math.min(300, WIDTH * 1);

    // let chapterWidth = ENV.WEB
    //   ? this.CHAPTER_WIDTH
    //   : this.CHAPTER_WIDTH - context.sizes.large * props.levelsDeep;
    let chapterWidth = this.CHAPTER_WIDTH;

    return chapterWidth;
  };

  updateChapterWidth = () => {
    let chapterWidth = this.chapterWidth();
    console.log("updating chapterwidth", chapterWidth);
    this.setState({ chapterWidth });
  };

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !textHelpers.compareObjects(prevProps.chapter, this.props.chapter) ||
      prevProps.lastFetchedAt != this.props.lastFetchedAt
    ) {
      this.asyncUpdateChapter(this.props.chapter).catch((e) =>
        console.error("[Chapter] asyncUpdateChapter failed:", e),
      );
    }
    if (this.props.expanded != prevProps.expanded) {
      this.toggleExpanded();
    }
    if (this.props.levelsDeep != prevProps.levelsDeep) {
      this.updateChapterWidth();
    }
  }

  componentWillUnmount() {
    ScreenOrientation.removeOrientationChangeListeners();
    if (this.screenWidthInterval) clearInterval(this.screenWidthInterval);
    this.unsubscribeFocus && this.unsubscribeFocus();
    this.unsubscribeBlur && this.unsubscribeBlur();
    this.unsubscribe();
    if (ENV.WEB) window.removeEventListener("focus", this.fetchChapterIfStale);
    this.appStateListener?.remove();
  }

  _handleAppStateChange = (nextAppState) => {
    if (!ENV.WEB) {
      if (
        this.state.appState.match(/inactive|background/) &&
        nextAppState === "active"
      ) {
        this.fetchChapter();
      }
      this.setState({ appState: nextAppState });
    }
  };

  unsubscribe = () => {
    this.unsubscribeRedux && this.unsubscribeRedux();
    this.unsubscribeRedux = null;
  };

  subscribe = async () => {
    if (!!this.unsubscribeRedux) return;
    this.unsubscribeRedux = store.subscribe(() => {
      let { chapters, preferences } = store.getState();
      if (!!this.props.chapter.id) {
        let chapter = chapters.find((c) => c.id == this.props.chapter.id);
        if (!!chapter) {
          if (JSON.stringify(chapter) !== JSON.stringify(this.state.chapter)) {
            console.log("------------ from redux:", chapter);
            this.asyncUpdateChapter(chapter).catch((e) =>
              console.error("[Chapter] asyncUpdateChapter failed:", e),
            );
          } else if (this.state.fetching) {
            // Data arrived via another chapter's fetch (e.g. parent) — our own
            // fetch is redundant. Clear loading so the spinner doesn't hang.
            this.setState({ loading: false, fetching: false, initialFetchComplete: true });
          }
        }
      }
      if (preferences.detailsMode != this.state.globalDetailsMode) {
        // console.log(preferences.detailsMode);
        this.setState({
          details: preferences.detailsMode,
          globalDetailsMode: preferences.detailsMode,
        });
      }
    });
  };

  toggleExpanded = async (force = undefined) => {
    let { chapter, expanded, editing, composer } = this.state;
    if (composer && !editing) {
      // console.log("expanding,", chapter);
      let subRange = 1;
      let subChapters =
        this.props.subChapters || chapterHelpers.subChapters(chapter);
      if (!!subChapters.length)
        subRange = subChapters[subChapters.length - 1].range;
      await this.setState({
        editing: true,
        expanded: true,
        editingTitle: chapter.title !== "+" ? chapter.title : "",
        // editingTitle: "",
        subRange,
      });
      this.expandAnim();
      return;
    }
    if (editing) {
      this.handleFocusTitle();
      return;
    }

    let newExpanded = force !== undefined ? force : !expanded;
    if (newExpanded) {
      this.fetchChapter();
      if (force && expanded && !this.props.zoomed) {
        this.toggleZoomed();
      }
      // this.props.onCollapse && this.props.onCollapse();
    } else {
      if (this.props.zoomed) {
        this.toggleZoomed();
      }
      // this.props.onExpand && this.props.onExpand();
    }
    // if (!newExpanded) {
    //   this.expandAnim(0);
    //   await new Promise((r) => setTimeout(r, 400));
    // }
    await this.setState({ expanded: newExpanded });
    // if (newExpanded) {
    //   this.expandAnim();
    // }
  };

  expandAnim = (toValue = 1) => {
    Animated.timing(this.state.expandingHeightAnim, {
      toValue,
      duration: 400,
      useNativeDriver: false,
    }).start();
  };

  toggleZoomed = () => {
    let { chapter, expanded } = this.state;
    let { zoomed, onZoomOut, onZoomIn } = this.props;
    if (!expanded && !zoomed) {
      this.toggleExpanded();
    }
    if (zoomed) onZoomOut && onZoomOut(chapter.id);
    else onZoomIn && onZoomIn(chapter.id);
  };

  handleZoomOut = (subChapterId) => {
    let { chapter, zoomedChapterIds } = this.state;
    zoomedChapterIds.splice(zoomedChapterIds.indexOf(subChapterId), 1);
    this.setState({ zoomedChapterIds });
  };

  handleZoomIn = (subChapterId) => {
    let { chapter, zoomedChapterIds } = this.state;
    zoomedChapterIds.push(subChapterId);
    this.setState({ zoomedChapterIds });
    this.props.onZoomIn && this.props.onZoomIn(chapter.id); // propagate zoom updawards
  };

  fetchChapterIfStale = async () => {
    let { lastFetchedAt } = this.state;
    let now = new Date().getTime();
    let tenMinAgo = now - 1000 * 60 * 10;
    if (!lastFetchedAt || lastFetchedAt < tenMinAgo) {
      this.fetchChapter();
    } else {
      console.log("chapter not stale, no need to refetch");
    }
  };

  fetchChapter = async ({ autoSelectTarot = false } = {}) => {
    let { chapter, autoCreate, initialFetchComplete } = this.state;
    console.log("fetching chapter", chapter?.id);
    if (autoCreate || chapter?.id == "root") return;
    await this.setState({
      loading: !initialFetchComplete,
      fetching: true,
      lastFetchedAt: new Date().getTime(),
    });

    let selectedDate = this.props.route?.params?.date;
    try {
      let res = await chapterActions.show(chapter.id, selectedDate);
      if (res?.success) {
        if (!initialFetchComplete) {
          if (res.chapter.current) {
            if (ENV.WEB)
              window.addEventListener("focus", this.fetchChapterIfStale);
          }
          if (this.props.expanded) {
            let subChapters = chapterHelpers.subChapters(res.chapter);
            let zoomedChapterId = subChapters?.find((c) => c.current)?.id;
            if (!!zoomedChapterId && ENV.WEB) {
              this.setState({ zoomedChapterIds: [zoomedChapterId] });
            } else {
              if (chapter.range == 1) {
                this.props.expandSiblings && this.props.expandSiblings();
              }
            }
          }
        }

        await this.asyncUpdateChapter(res.chapter, { autoSelectTarot });
        if (res.chapter?.current) this.fetchPrevChapterTarot(res.chapter);

        if (res.chapter?.current) {
          if (this.props.onFinishLoading) {
            this.props.onFinishLoading();
          }
          if (!this.props.zoomed) {
            this.toggleZoomed();
          }
        }
      } else if (!res && store.getState().app?.isOnline === false && !initialFetchComplete) {
        const cached = await storageActions.fetchItem("cached_chapter_today", null);
        if (cached?.success && cached.chapter?.id === chapter.id) {
          await this.asyncUpdateChapter(cached.chapter, { autoSelectTarot });
        }
      }
    } finally {
      this.setState({ loading: false, fetching: false });
    }
  };

  fetchPrevChapterTarot = async (chapter) => {
    if (chapterHelpers.atemporal(chapter)) return;
    if (chapter.range !== 1) {
      this.setState({ prevChapterTarotMoment: null, prevChapterData: null });
      return;
    }
    const prevRes = await chapterActions.getPreviousChapter(chapter.id);
    if (!prevRes?.chapter) {
      this.setState({ prevChapterTarotMoment: null, prevChapterData: null });
      return;
    }
    const prevChapter = prevRes.chapter;
    const firstTarot = (prevChapter.moments || [])
      .filter((m) => m.value?.category === 'tarot')
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0];
    if (firstTarot && !firstTarot.completed_at) {
      this.setState({ prevChapterTarotMoment: firstTarot, prevChapterData: prevChapter });
    } else {
      this.setState({ prevChapterTarotMoment: null, prevChapterData: null });
    }
  };

  asyncUpdateChapter = async (chapter, { autoSelectTarot = false } = {}) => {
    let data = this.updateChapter(chapter, { autoSelectTarot });
    this.state.colorAnim.setValue(0);
    await this.setState(data);
    Animated.timing(this.state.colorAnim, {
      toValue: 1,
      duration: 2000,
      useNativeDriver: false,
    }).start(() => {
      this.setState({ prevChapterColor: this.state.chapterColor });
    });
  };

  updateChapter = (chapter, { autoSelectTarot = false } = {}) => {
    let startDate = timeHelpers.dateToDateTime(chapter.start_at);
    let endDate = timeHelpers.dateToDateTime(chapter.end_at);
    let isToday =
      timeHelpers.wasToday(startDate) && timeHelpers.wasToday(endDate);
    let atemporal = chapterHelpers.atemporal(chapter);

    let prevChapterColor =
      this?.state?.chapterColor ||
      colorHelpers.hexToRgbaString(this.context.colors.empty);
    let chapterColor = chapterHelpers.getColor(
      chapter,
      this.context.colors,
      this.context.colorScheme,
    );
    chapterColor = colorHelpers.hexToRgbaString(chapterColor);

    // console.log("-------compare colors", chapterColor, prevChapterColor);

    let data = {
      chapter,
      isToday,
      atemporal,
      loading: false,
      fetching: false,
      initialFetchComplete: true,
      chapterColor,
      prevChapterColor,
    };

    // Today's tarot is intentionally NOT auto-selected/expanded — the card shows
    // in the header (renderTarotHeader) and the user taps it to open the editor.
    // (autoSelectTarot is kept on the call signatures but no longer auto-opens.)

    return data;
  };

  render() {
    let {
      chapter,
      expanded,
      editing,
      level,
      composer,
      isToday,
      editingTitle,
      atemporal,
      chapterWidth,
      focusedChapterId,
      expandingHeightAnim,
      details,
      chapterColor,
      prevChapterColor,
      listView,
    } = this.state;

    let {
      hiddenLevels,
      zoomed,
      subChaptersOnly,
      levelsDeep,
      parentChapter,
      handleRootChapterLayout,
      onRootChapterLayout,
    } = this.props;

    let backgroundColor = this.context.colors.empty;
    try {
      backgroundColor =
        composer && !editing
          ? this.context.colors.empty
          : this.state.colorAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [prevChapterColor, chapterColor],
            });
    } catch (e) {
      backgroundColor = this.context.colors.empty;
    }

    // let hasCompletedMoments = !!chapter?.moments?.some((m) => !!m.completed_at);
    // let colorNames = [
    //   ...(
    //     chapter?.moments?.map((m) =>
    //       hasCompletedMoments
    //         ? !!m.completed_at
    //           ? m.value?.color
    //           : null
    //         : m.value?.color
    //     ) || []
    //   ).filter((c) => !!c),
    // ];
    // colorNames = textHelpers.uniq(colorNames);
    // let hexes = colorNames.map((c) =>
    //   valueHelpers.colorAsHex(c, this.context.colorScheme)
    // );
    // let backgroundColor =
    //   atemporal || (composer && !editing)
    //     ? this.context.colors.empty
    //     : !!hexes.length
    //     ? colorHelpers.averageColor(hexes)
    //     : this.context.colors.darkForeground;

    if (hiddenLevels >= level) {
      return this.renderSubChapters();
    }

    let widthStyle = ENV.WEB
      ? { minWidth: listView ? null : chapterWidth }
      : {
          minWidth: chapterWidth,
          maxWidth: chapterWidth,
        };

    let expandingHeight = expandingHeightAnim.interpolate({
      inputRange: [0, 1],
      outputRange: [0, this.context.sizes.HEIGHT],
    });

    let focused = this.props.focusedChapterId == chapter.id;

    let shortStartAt = timeHelpers.dateToDateTime(chapter.start_at);
    shortStartAt = textHelpers.formatDate(shortStartAt, true, false, false);
    let headerTooltip = shortStartAt;
    if (chapter.range > 1) {
      let shortEndAt = timeHelpers.dateToDateTime(chapter.end_at);
      shortEndAt = textHelpers.formatDate(shortEndAt, true, false, false);
      headerTooltip = `${shortStartAt}-${shortEndAt}`;
    }

    const hasTarotHeader =
      !atemporal &&
      ((chapter.moments || []).some((m) => m.value?.category === "tarot") ||
        chapter.range === 1 ||
        (chapter.range >= 28 && chapter.range <= 31));

    if (subChaptersOnly) {
      return (
        <View
          onLayout={(e) => {
            !!this.props.onLayout && this.props.onLayout(e, this.ref);
          }}
          ref={(r) => (this.ref = r)}
          style={[
            this.styles().wrapper,
            listView && this.styles().listViewWrapper,
            widthStyle,
            this.styles().rootChapterWrapper,
            this.props.style,
            // { borderWidth: 2, borderColor: "green" },
          ]}
        >
          <View style={this.styles().body}>{this.renderSubChapters()}</View>
        </View>
      );
    }
    return (
      <HeaderHeightContext.Consumer>
        {(headerHeight) => (
          <View
            ref={(r) => (this.wrapperRef = r)}
            onLayout={(e) => {
              !!this.props.onLayout && this.props.onLayout(e);
              if (!!onRootChapterLayout && chapter.range == 1 && chapter.current) {
                this.wrapperRef.measure(
                  // this.props.rootScrollerRef,
                  (x, y, width, height, pageX, pageY) => {
                    // console.warn("onRootChapterLayout", pageY);
                    onRootChapterLayout(pageY);
                  },
                );
              }
            }}
            style={[
              this.styles().wrapper,
              listView && this.styles().listViewWrapper,
              widthStyle,
              // isToday && this.styles().todayWrapper,
              // isToday && { borderColor: backgroundColor },
              isToday &&
                !ENV.WEB && {
                  minHeight:
                    this.context.sizes.HEIGHT -
                    headerHeight -
                    this.context.sizes.COMPOSER_HEIGHT -
                    0,
                  // backgroundColor: "red",
                },
              this.props.style,
              !expanded && this.props.collapsedStyle,
              zoomed && ENV.WEB && { minWidth: "80%" },
              atemporal && { borderWidth: 0, minWidth: 0 },
              // { justifyContent: "stretch" },
            ]}
          >
            <Animated.View
              style={[
                { alignSelf: "stretch" },
                this.styles().innerWrapper,
                !expanded && this.props.collapsedStyle,
                // isToday &&
                //   ENV.WEB && {
                //     borderWidth: 2,
                //     borderTopWidth: 0,
                //     borderColor: backgroundColor,
                //   },
                atemporal && { borderTopWidth: 1 },
                // !chapter.current && !isFocused && { opacity: 0.8 },
                // ENV.WEB && // dim other chapters
                //   !chapter.current &&
                //   this.props.focusedChapterId != chapter.id && { opacity: 0.6 },
                // {
                //   backgroundColor: colorHelpers.hexToRgbaString(
                //     backgroundColor,
                //     0.05
                //   ),
                // },
              ]}
            >
              <Draggable
                disabled
                flex
                style={[
                  this.styles().wrapper,
                  listView && this.styles().listViewWrapper,
                  { zIndex: 2 },
                  // { width: "100%" }
                ]}
                onDragStart={() => {
                  // this.setState({ isDragging: true });
                  // this.listenForMetaKey();
                }}
                onDragEnd={() => {
                  // this.setState({ isDragging: false, metaKey: false });
                  // this.unsubscribeRedux();
                }}
                // item={moment}
                global
              >
                {(isDragging) => {
                  return (
                    <HoverableTooltip
                      text={headerTooltip}
                      onMouseEnter={() =>
                        this.setState({ headerIsHovered: true })
                      }
                      onMouseLeave={() =>
                        this.setState({ headerIsHovered: false })
                      }
                      // onHoverIn={() => this.setState({ headerIsHovered: true })}
                      // onHoverOut={() => this.setState({ headerIsHovered: false })}
                    >
                      {(isHovered) => {
                        return (
                          <Animated.View
                            style={[
                              (!composer || editing) && this.styles().header,
                              expanded && this.styles().expandedHeader,
                              {
                                zIndex: 2,
                                backgroundColor,
                                borderTopRightRadius: ENV.WEB
                                  ? this.context.sizes.borderRadius - 3
                                  : 0,
                                borderTopLeftRadius: ENV.WEB
                                  ? this.context.sizes.borderRadius - 3
                                  : 0,
                              },
                              atemporal && {
                                borderColor: this.context.colors.trim,
                                borderBottomWidth: 1,
                              },
                              hasTarotHeader && {
                                paddingLeft: this.context.sizes.base * this.context.sizes.mobileIncrease,
                              },
                            ]}
                          >
                            <View style={{ flexDirection: "row", alignItems: "center" }}>
                              {this.renderTarotHeader()}
                              <TouchableOpacity
                                style={[{ flex: 1 }]}
                                // haptics={"warn"}
                                onPress={
                                  ENV.WEB && !composer
                                    ? undefined
                                    : () => this.toggleExpanded()
                                }
                                onLongPress={() => {
                                  if (ENV.WEB) {
                                    this.setState({
                                      editing: true,
                                      expanded: true,
                                      editingTitle: chapter.title,
                                    });
                                  } else {
                                    if (focused) {
                                      this.props.unfocusChapter &&
                                        this.props.unfocusChapter();
                                    } else {
                                      this.props.focusChapter(chapter.id);
                                    }
                                  }
                                }}
                                // onLongPress={this.toggleZoomed}
                              >
                                <View
                                  style={[
                                    this.styles().row,
                                    { flexWrap: "nowrap" },
                                  ]}
                                >
                                  {!editing && !composer && (
                                    <TouchableOpacity
                                      light={!atemporal}
                                      innerRef={(el) => { this.expandRef = el; }}
                                      tabIndex={-1}
                                      onKeyDown={(e) => this.handleExpandButtonKeyDown(e)}
                                      onPress={(e) => {
                                        if (ENV.WEB) e.stopPropagation();
                                        this.toggleExpanded();
                                      }}
                                      style={{
                                        marginRight: this.context.sizes.base,
                                        borderWidth: isToday ? 1 : 0,
                                        borderColor: colorHelpers.hexToRgbaString(
                                          this.context.colors.lightForeground,
                                          0.6,
                                        ),
                                        borderRadius: 999,
                                        width: this.context.sizes.large,
                                        height: this.context.sizes.large,
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <FontAwesome5
                                        name={
                                          expanded ? "caret-down" : "caret-right"
                                        }
                                        color={
                                          atemporal
                                            ? this.context.colors.foreground
                                            : this.context.colors.lightForeground
                                        }
                                      />
                                    </TouchableOpacity>
                                  )}
                                  {/*<TouchableOpacity onPress={() => null}>*/}
                                  {this.renderTitle()}
                                  {/*</TouchableOpacity>*/}
                                  {this.renderHeaderButtons(isHovered)}
                                </View>
                                {this.renderSubTitle()}
                              </TouchableOpacity>
                            </View>
                            {this.renderWingColors()}
                          </Animated.View>
                        );
                      }}
                    </HoverableTooltip>
                  );
                }}
              </Draggable>

              {editing ? (
                <View style={[this.styles().body, { width: chapterWidth }]}>
                  <ChapterForm
                    title={editingTitle}
                    chapter={chapter}
                    parentChapter={parentChapter}
                    range={this.state.subRange}
                    onDelete={this.props.refreshParentChapter}
                    onCancel={() => {
                      let expanded = this.state.expanded;
                      if (composer) {
                        expanded = false;
                      }
                      this.setState({
                        editing: false,
                        expanded,
                        editingTitle: "",
                      });
                    }}
                    allowDelete={!composer}
                    onUpdateTitle={(t) => this.setState({ editingTitle: t })}
                    onUpdateChapter={(chapter) => {
                      this.setState({
                        chapter,
                        editingTitle: chapter.title,
                        loading: false,
                        editing: false,
                        composer: false,
                      });
                      this.props.addSubChapter &&
                        this.props.addSubChapter(chapter);
                    }}
                  />
                </View>
              ) : !expanded ? (
                this.renderBadges() // this.renderNodes()
              ) : (
                <Animated.View
                  style={[
                    this.styles().body,
                    // {
                    //   overflow: "hidden",
                    //   maxHeight: expandingHeight,
                    // },
                  ]}
                >
                  {this.renderScratchPad()}
                  {this.renderNodes()}
                  {chapter.range > 7 && this.renderSuggestionsFromBelow()}
                  {chapter.range <= 7 && this.renderRecents()}
                  {this.renderSubChapters()}
                </Animated.View>
              )}
            </Animated.View>
          </View>
        )}
      </HeaderHeightContext.Consumer>
    );
  }

  renderTitle = () => {
    let {
      chapter,
      editing,
      editingTitle,
      composer,
      isToday,
      atemporal,
      chapterWidth,
    } = this.state;
    let title = chapterHelpers.getTitle(chapter, isToday);
    let shortDate = timeHelpers.dateToDateTime(chapter.start_at);
    shortDate = textHelpers.formatDate(shortDate, true, false, false);
    // if (composer && !editing) title = "+";
    // if (!editing && !composer && !atemporal && !ENV.WEB) {
    if (!editing && !composer && !ENV.WEB) {
      return (
        <Text numberOfLines={1} light={!atemporal} style={this.styles().title}>
          {!(composer && !editing) &&
            chapter.start_at == chapter.end_at &&
            !atemporal &&
            `${shortDate} `}
          {/*chapter.current && "*"*/}
          {title}
        </Text>
      );
    } else if (composer && !editing) {
      // <Text button style={{ minWidth: 50, textAlign: "center" }}>
      return (
        <Text
          center
          button
          style={
            ENV.WEB
              ? {
                  width: ENV.WEB ? undefined : chapterWidth,
                  marginRight: ENV.WEB ? 0 : this.context.sizes.large,
                  borderRadius: this.context.sizes.borderRadius,
                }
              : {
                  borderRadius: 0,
                  width: chapterWidth,
                  marginRight: 0,
                  padding:
                    this.context.sizes.base * this.context.sizes.mobileIncrease,
                }
          }
        >
          +
        </Text>
      );
    } else {
      return (
        <View style={{ flexDirection: "row" }}>
          {!atemporal && !composer && (
            <Text light>
              {!(composer && !editing) &&
                chapter.start_at == chapter.end_at &&
                `${shortDate} `}
              {!composer &&
                !editing &&
                chapter.range == 7 &&
                (chapter.title?.startsWith("Into")
                  ? "Week going "
                  : "Week of ")}
              {/*chapter.current && "*"*/}
            </Text>
          )}

          <TextInput
            inputRef={(ref) => {
              return (this[`ref-title`] = ref);
            }}
            // autoWidth
            underline={editing}
            light
            style={[
              this.styles().title,
              atemporal && { color: this.context.colors.foreground },
            ]}
            placeholder={composer && editing ? "New Chapter" : title}
            placeholderTextColor={
              composer && editing
                ? this.context.colors.trim
                : atemporal
                  ? this.context.colors.foreground
                  : this.context.colors.lightForeground
            }
            onChangeText={(t) => this.setState({ editingTitle: t })}
            onAltUp={() => {
              if (this.justFocusedTitle) {
                this.justFocusedTitle = false;
                return;
              }
              this.toggleExpanded(false);
            }}
            onAltDown={() => {
              if (this.state.expanded) {
                this.handleFocusComposer();
              } else {
                this.toggleExpanded(true);
              }
            }}
            onAltLeft={() => {
              if (this.props.zoomed) {
                this.props.onZoomOut && this.props.onZoomOut(this.state.chapter.id);
              }
              this.props.onFocusPreviousChapter &&
                this.props.onFocusPreviousChapter("title");
            }}
            onAltRight={() => {
              if (this.props.zoomed) {
                this.props.onZoomOut && this.props.onZoomOut(this.state.chapter.id);
              }
              this.props.onFocusNextChapter &&
                this.props.onFocusNextChapter("title");
            }}
            onNatUp={() => {
              this.props.onFocusParentComposer &&
                this.props.onFocusParentComposer();
            }}
            onNatDown={() => {
              if (this.state.expanded) {
                if (!!this.tarotBulletInputRef && !!this.state.selectedTarotMoment) {
                  this.tarotBulletInputRef.focus();
                } else if (!!this.scratchPadRef) {
                  this.scratchPadRef.focus();
                } else if (!!this.momentList?.handleFocusFirstItem) {
                  this.momentList.handleFocusFirstItem();
                } else if (!!this.momentList?.handleFocusFirstMoment) {
                  this.momentList.handleFocusFirstMoment();
                }
              } else {
                this.setState({ expanded: true });
              }
            }}
            onMetaDown={() => {
              if (this.state.expanded) {
                !!this.momentList?.handleFocusComposer &&
                  this.momentList.handleFocusComposer();
              } else {
                this.toggleExpanded(true);
              }
            }}
            onMetaUp={() => {
              if (this.props.onFocusParentTitle)
                this.props.onFocusParentTitle();
              else
                this.props.onFocusParentComposer &&
                  this.props.onFocusParentComposer();
            }}
            onMetaCtrlRight={() =>
              RootNavigation.push("Chapter", { id: chapter.id })
            }
            onMetaShiftN={() =>
              this.context.openNarrative(this.state.chapter, this.fetchChapter)
            }
            onMetaShiftD={() =>
              this.context.openNarrative(this.state.chapter, this.fetchChapter)
            }
            onMetaCtrlShiftRight={() =>
              RootNavigation.push(
                "Chapter",
                { id: chapter.id },
                { newTab: true },
              )
            }
            onFocus={() => {
              this.props.scrollToChapter && this.props.scrollToChapter(chapter);
            }}
            onTab={() => {
              const refs = this.getHeaderButtonRefs();
              if (refs.length) refs[0].focus();
            }}
            onShiftTab={() => {
              if (this.expandRef) this.expandRef.focus();
              else if (this.tarotRef) this.tarotRef.focus();
            }}
          >
            {editingTitle}
          </TextInput>
        </View>
      );
    }
  };

  renderSubTitle = () => {
    return null;
  };

  renderWingColors = () => {
    return;
    if (ENV.WEB) return;
    let { wingColors } = this.props;
    if (!!wingColors?.left || !!wingColors?.right) {
      return (
        <View
          style={{ ...StyleSheet.absoluteFillObject }}
          pointerEvents={"none"}
        >
          {!!wingColors.left && (
            <View
              style={{
                position: "absolute",
                top: 5,
                bottom: 5,
                left: 5,
                width: 3,
                right: undefined,
                backgroundColor: wingColors.left,
                borderRadius: 10,

                // width: 0,
                // height: 0,
                // backgroundColor: "transparent",
                // borderStyle: "solid",
                // borderLeftWidth: 30,
                // borderRightWidth: 30,
                // borderBottomWidth: 10,
                // borderLeftColor: "transparent",
                // borderRightColor: "transparent",
                // borderBottomColor: wingColors.left,
                // transform: [{ rotate: "90deg" }],
              }}
            />
          )}
          {!!wingColors.right && (
            <View
              style={{
                position: "absolute",
                top: 5,
                bottom: 5,
                right: 5,
                width: 3,
                left: undefined,
                borderRadius: 10,
                backgroundColor: wingColors.right,
              }}
            />
          )}
        </View>
      );
    }
  };

  handleAddTarotFromPrevious = async () => {
    const { chapter } = this.state;
    const res = await chapterActions.getPreviousChapter(chapter.id);
    if (!res?.chapter) return;
    const prevMoments = res.chapter.moments || [];
    const storeValues = store.getState().values;
    const tarotMoment = prevMoments.find((m) => {
      const v = m.value || storeValues.find((v) => v.id === m.value_id);
      return v?.category === "tarot";
    });
    if (!tarotMoment) return;
    const valueId = tarotMoment.value_id || tarotMoment.value?.id;
    if (!valueId) return;
    await chapterActions.pinValue(chapter.id, valueId);
    this.fetchChapter({ autoSelectTarot: true });
  };

  renderTarotHeader = () => {
    const { chapter, selectedTarotMoment, atemporal } = this.state;
    if (atemporal) return null;
    if (chapter.id === "auto") return null;
    const allTarotMoments = (chapter.moments || [])
      .filter((m) => m.value?.category === "tarot")
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    const tarotMoments = allTarotMoments.slice(0, 1);
    const isDay = chapter.range === 1;
    const isMonth = chapter.range >= 28 && chapter.range <= 31;

    if (!tarotMoments.length) {
      if (!isDay && !isMonth) return null;
      return (
        <TouchableOpacity
          onPress={this.handleAddTarotFromPrevious}
          style={{ marginRight: this.context.sizes.small, cursor: "pointer" }}
        >
          <View style={{
            width: 22, height: 22, borderRadius: 11,
            backgroundColor: "#fff",
            alignItems: "center", justifyContent: "center",
            opacity: 0.5,
          }}>
            <Feather name="plus" size={13} color="#000" />
          </View>
        </TouchableOpacity>
      );
    }

    return (
      <View style={{ flexDirection: "row", alignItems: "center", marginRight: this.context.sizes.small }}>
        {tarotMoments.map((moment) => {
          const cardText = moment.text || "";
          const firstLine = cardText.split("\n")[0];
          const card = tarotHelpers.parseCard(firstLine);
          const isSelected = selectedTarotMoment?.id === moment.id;
          const isIncomplete = !moment.completed_at;
          const cardNode = card ? (
            <TarotCard card={card} size="small" incomplete={isIncomplete} />
          ) : (
            <View style={{
              width: 22, height: 22, borderRadius: 11,
              backgroundColor: isIncomplete ? "transparent" : "#fff",
              borderWidth: isIncomplete ? 2 : 0,
              borderColor: "#fff",
              alignItems: "center", justifyContent: "center",
            }}>
              <Text style={{ fontSize: 13, lineHeight: 22 }}>🃏</Text>
            </View>
          );
          return (
            <TouchableOpacity
              key={moment.id}
              innerRef={tarotMoments.indexOf(moment) === 0 ? (el) => { this.tarotRef = el; } : undefined}
              tabIndex={tarotMoments.indexOf(moment) === 0 ? -1 : undefined}
              onKeyDown={tarotMoments.indexOf(moment) === 0 ? (e) => {
                if (!ENV.WEB) return;
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  const next = isSelected ? null : moment;
                  this.setState({ selectedTarotMoment: next });
                  if (next && !this.state.expanded) this.toggleExpanded();
                } else if (e.key === 'Tab') {
                  e.preventDefault();
                  if (e.shiftKey) {
                    // nothing before tarot
                  } else {
                    this.expandRef?.focus();
                  }
                }
              } : undefined}
              onPress={() => {
                const next = isSelected ? null : moment;
                this.setState({ selectedTarotMoment: next });
                if (next && !this.state.expanded) this.toggleExpanded();
              }}
              style={{
                marginRight: this.context.sizes.tiny,
                opacity: isSelected ? 1 : 0.7,
                cursor: "pointer",
              }}
            >
              {cardNode}
            </TouchableOpacity>
          );
        })}
      </View>
    );
  };

  // removes every open pin that had no activity that day (no completion,
  // no moment text, no value edits, no progress)
  handleClearOpenItems = async (e) => {
    e?.stopPropagation && e.stopPropagation();
    let conf = await alertActions.confirm(
      "Remove all untouched open items from this chapter?",
    );
    if (!conf) return;
    await this.setState({ loading: true });
    let res = await chapterActions.clearOpenMoments(this.state.chapter.id);
    await this.setState({ loading: false });
    if (!res?.success) {
      alert("Could not clear open items");
      return;
    }
    this.fetchChapter();
  };

  renderHeaderButtons = (isHovered) => {
    let { expanded, loading, editing, composer, chapter, atemporal, details } =
      this.state;
    let { zoomed, hasSiblings } = this.props;
    let color = atemporal
      ? this.context.colors.foreground
      : this.context.colors.lightForeground;
    if (composer) return null;
    let hasIncompleteMoments = !!chapter?.moments?.find(
      (m) => !m.completed_at && !m.value?.is_note,
    );
    let focused = this.props.focusedChapterId == chapter.id;
    let showButtons = ENV.WEB ? isHovered : focused;

    this.headerButtonRefs = new Array(8).fill(null);

    return (
      <View
        style={{
          flex: 1,
          alignSelf: "flex-end",
          flexDirection: "row",
          justifyContent: "flex-end",
          height: this.context.sizes.default * 1.5,
          alignItems: "center",
        }}
      >
        <View style={{ marginRight: this.context.sizes.base }}>
          {loading && (
            <ActivityIndicator
              color={color}
              size={"small"}
              // style={{ position: "absolute", right: 0 }}
              style={this.styles().headerButton}
            />
          )}
        </View>
        {ENV.WEB && showButtons && zoomed && hasIncompleteMoments && (
          <HoverableTooltip text="Clear untouched open items">
            <TouchableOpacity
              haptics
              style={{ marginRight: this.context.sizes.base }}
              innerRef={(el) => {
                this.headerButtonRefs[7] = el;
              }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 7)}
              onPress={this.handleClearOpenItems}
            >
              <MaterialCommunityIcons
                name={"broom"}
                style={this.styles().headerButton}
                color={color}
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {ENV.WEB && showButtons && zoomed && (
          <HoverableTooltip text={`Cycle Details [${details}]`}>
            <TouchableOpacity
              haptics
              style={{ marginRight: this.context.sizes.base }}
              innerRef={(el) => { this.headerButtonRefs[0] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 0)}
              onPress={(e) => {
                e.stopPropagation();
                this.cycleDetails();
              }}
            >
              <Entypo
                name={`list`}
                style={this.styles().headerButton}
                color={color}
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {ENV.WEB && showButtons && zoomed && (
          <HoverableTooltip text="View chapter">
            <TouchableOpacity
              haptics
              style={{ marginRight: this.context.sizes.base }}
              innerRef={(el) => { this.headerButtonRefs[1] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 1)}
              // onPress={this.toggleZoomed}
              onPress={(e) => {
                e.stopPropagation();
                RootNavigation.push("Chapter", { id: chapter.id }, e);
              }}
            >
              <FontAwesome
                name={`sticky-note-o`}
                style={this.styles().headerButton}
                color={color}
                // color={this.context.colors.trim}
                // <Feather name='edit' />
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {showButtons && zoomed && !composer && !atemporal && (
          <HoverableTooltip text="Narrative">
            <TouchableOpacity
              style={{ marginRight: this.context.sizes.base }}
              innerRef={(el) => { this.headerButtonRefs[2] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 2)}
              onPress={(e) => {
                if (ENV.WEB) e.stopPropagation();
                this.context.openNarrative(this.state.chapter, this.fetchChapter);
              }}
            >
              <Feather
                name="book-open"
                style={this.styles().headerButton}
                color={color}
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {!composer && showButtons && zoomed && (hasIncompleteMoments || true) && (
          <HoverableTooltip text="Rollover Incomplete">
            <TouchableOpacity
              // haptics={"warn"}
              style={{ marginRight: this.context.sizes.base }}
              innerRef={(el) => { this.headerButtonRefs[3] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 3)}
              // onPress={this.toggleZoomed}
              onPress={async (e) => {
                e.stopPropagation();
                let res = await alertActions.confirm({
                  title: "Suggestions",
                  subtitle: "View suggestions from...",
                  options: [
                    "Rollover Incomplete",
                    "Prevous chapter",
                    "Above",
                    "Below",
                  ],
                });
                if (res == 1) {
                  this.props.onRollover && this.props.onRollover(chapter.id);
                } else if (res == 2) {
                  this.setState({ hideRolloverSuggestions: false });
                } else if (res == 3) {
                  this.setState({ hideSuggestionsFromAbove: false });
                } else if (res == 4) {
                  this.setState({
                    expandSuggestions: true,
                    hideSuggestionsFromBelow: false,
                  });
                }
              }}
            >
              <MaterialCommunityIcons
                name={`application-import`}
                style={this.styles().headerButton}
                color={color}
                // color={this.context.colors.trim}
                // <Feather name='edit' />
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {!composer && ((showButtons && zoomed) || editing) && (
          <HoverableTooltip text={editing ? "Cancel" : "Edit Chapter"}>
            <TouchableOpacity
              // haptics={"warn"}
              innerRef={(el) => { this.headerButtonRefs[4] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 4)}
              onPress={(e) => {
                e.stopPropagation();
                this.setState({
                  editing: !editing,
                  expanded: true,
                  editingTitle: chapter.title,
                });
              }}
            >
              <Ionicons
                name={`settings${editing ? "" : "-outline"}`}
                style={this.styles().headerButton}
                color={color}
                // color={this.context.colors.trim}
                // <Feather name='edit' />
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {showButtons && !!this.props.onHide && zoomed && (
          <HoverableTooltip text={`Hide Chapter`}>
            <TouchableOpacity
              haptics
              style={{ marginLeft: this.context.sizes.base }}
              innerRef={(el) => { this.headerButtonRefs[5] = el; }}
              tabIndex={-1}
              onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 5)}
              onPress={(e) => {
                e.stopPropagation();
                this.handleHide();
              }}
            >
              <MaterialCommunityIcons
                name={"close"}
                style={this.styles().headerButton}
                color={color}
              />
            </TouchableOpacity>
          </HoverableTooltip>
        )}
        {ENV.WEB &&
          showButtons &&
          (hasSiblings || true) &&
          !composer &&
          !atemporal && (
            <HoverableTooltip text={zoomed ? "Zoom Out" : "Zoom In"}>
              <TouchableOpacity
                haptics
                style={{ marginLeft: this.context.sizes.base }}
                innerRef={(el) => { this.headerButtonRefs[6] = el; }}
                tabIndex={-1}
                onKeyDown={(e) => this.handleHeaderButtonKeyDown(e, 6)}
                onPress={(e) => {
                  e.stopPropagation();
                  this.toggleZoomed();
                }}
              >
                <MaterialCommunityIcons
                  name={zoomed ? "arrow-collapse" : "arrow-expand"}
                  // style={this.styles().headerButton}
                  size={this.context.sizes.smallItemHeight}
                  color={color}
                />
              </TouchableOpacity>
            </HoverableTooltip>
          )}
      </View>
    );
  };

  renderBadges = (completed = false) => {
    let { chapter, loading } = this.state;
    let moments = chapter?.moments || [];
    if (completed) {
      moments = moments.filter((m) => !!m.completed_at);
    } else {
      // moments = moments.filter((m) => !m.completed_at);
    }
    // let values = moments.map((m) =>
    //   chapter.values.find((v) => v.id == m.value_id)
    // );
    // console.log("collaped renderbadges........", chapter, moments, values);

    let sortedMoments = [...moments];
    sortedMoments.sort((a, b) => {
      let statusOrder = ["completion", "progress_at", "open", "note"];
      let statusA = momentHelpers.getStatus(a);
      let statusB = momentHelpers.getStatus(b);
      let statusAIndex = statusOrder.indexOf(statusA);
      let statusBIndex = statusOrder.indexOf(statusB);
      if (statusAIndex < statusBIndex) {
        return -1;
      } else if (statusAIndex == statusBIndex) {
        return 0;
      } else if (statusAIndex > statusBIndex) {
        return 1;
      }
    });
    if (moments?.length) {
      // console.log(moments);
      return (
        <View
          style={[
            this.styles().leftPadding,
            {
              marginBottom: this.context.sizes.base,
              marginTop: this.context.sizes.base,
              // zIndex: 99
            },
          ]}
        >
          <BadgeRow
            index={0}
            // values={values}
            // moments={[...moments, ...(this.props.suggestions || [])]}
            moments={sortedMoments}
            chapter={chapter}
            rootChapter={chapter}
            chapterMoments={chapter.moments}
            onUpdateChapter={async (chapter) => {
              this.setState({ chapter, autoCreate: false });
              this.props.addSubChapter && this.props.addSubChapter(chapter);
            }}
            // button={<Text onPress={() => this.setState({showSuggestions: false})}>x</Text>}
            // title={
            //   <TouchableOpacity onPress={() => {}}>
            //     <Text style={styleSheet.bullet}>
            //       {showSuggestions ? "x" : "..."}
            //     </Text>
            //   </TouchableOpacity>
            // }
            loading={loading}
            firstButton={() => {
              if (!chapter.text?.length) return null;
              return (
                <TouchableOpacity onPress={this.toggleExpanded} haptics>
                  <MaterialCommunityIcons
                    name={"text"}
                    size={
                      this.context.sizes.large *
                      this.context.sizes.mobileIncrease
                    }
                    style={{
                      color: this.context.colors.foreground,
                      marginRight: this.context.sizes.tiny,
                    }}
                  />
                </TouchableOpacity>
              );
            }}
          />
        </View>
      );
    }
  };

  renderScratchPad = () => {
    let { chapter, loading, expandScratchPad, showScratchPadActions, isToday } =
      this.state;
    if (!chapter.text?.length) return null;

    if (
      this.props.focusedChapterId != chapter.id &&
      !chapter.text?.length &&
      !isToday
    )
      return null;

    // if (!chapter.text?.length) return null;
    // if (loading) return null;
    return (
      <View
        style={{
          // zIndex: 2,
          marginBottom: 0,
          borderColor: this.context.colors.trim,
          // borderBottomWidth: 1,
          backgroundColor: this.context.colors.fill,
          flexDirection: "row",
          margin: this.context.sizes.base,
          // margin: this.context.sizes.base - (expandScratchPad ? 1 : 0),
          // borderWidth: expandScratchPad ? 1 : 0,
          // borderRadius: expandScratchPad
          //   ? 0
          //   : this.context.sizes.smallBorderRadius,
          borderColor: this.context.colors.fill,
          borderRadius: this.context.sizes.smallBorderRadius,
          borderWidth: 1,
          backgroundColor: expandScratchPad
            ? this.context.colors.fill
            : this.context.colors.empty,
        }}
      >
        <ScrollView
          // scrollEnabled={false}
          keyboardShouldPersistTaps={"always"}
          nestedScrollEnabled
          style={{
            maxHeight: expandScratchPad
              ? undefined
              : this.context.sizes.default * 1.6 * 2,
          }}
        >
          <View
            style={[
              { flex: 1, zIndex: 1 },
              // !ENV.WEB && { paddingRight: this.context.sizes.giant },
              { paddingRight: this.context.sizes.giant },
            ]}
          >
            <ScratchPad
              inline
              // numberOfLines={expandScratchPad ? undefined : 2}
              chapter={chapter}
              onUpdateChapter={async (chapter) => {
                this.setState({ chapter, autoCreate: false });
                this.props.addSubChapter && this.props.addSubChapter(chapter);
              }}
              parentChapter={this.props.parentChapter}
              references={chapter.references}
              ref={(r) => (this.scratchPadRef = r)}
              onUpdateText={(text) =>
                this.setState({ chapter: { ...chapter, text } })
              }
              focusNext={this.momentList?.handleFocusFirstMoment}
              focusPrevious={this.handleFocusTitle}
              // onMetaUp={this.handleFocusTitle}
              onMetaUp={
                expandScratchPad
                  ? () => this.setState({ expandScratchPad: false })
                  : undefined
              }
              onMetaDown={
                expandScratchPad
                  ? undefined
                  : () => this.setState({ expandScratchPad: true })
              }
              onMetaCtrlRight={() =>
                RootNavigation.push("Chapter", { id: chapter.id })
              }
              onMetaCtrlShiftRight={() =>
                RootNavigation.push(
                  "Chapter",
                  { id: chapter.id },
                  { newTab: true },
                )
              }
              onFocus={() => {
                this.props.scrollToChapter &&
                  this.props.scrollToChapter(chapter);
              }}
              // showActions={showActions}
            />
          </View>
          {expandScratchPad && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingHorizontal: this.context.sizes.tiny,
                height: this.context.sizes.itemHeight,
              }}
            >
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Feather
                  name={"more-horizontal"}
                  size={this.context.sizes.default}
                  style={{
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                  onPress={() =>
                    this.setState({
                      showScratchPadActions: !showScratchPadActions,
                    })
                  }
                />
                {showScratchPadActions && (
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text smallButton selectedButton onPress={() => null}>
                      Clear
                    </Text>
                    <Text smallButton selectedButton onPress={() => null}>
                      Save as note
                    </Text>
                    <Text
                      smallButton
                      selectedButton
                      onPress={() => {
                        let refIds = richTextHelpers.getReferences(
                          chapter.text,
                        );
                        refIds.forEach((id) => {
                          chapterActions.pinValue(chapter.id, id);
                        });
                      }}
                    >
                      Pin all references
                    </Text>
                  </View>
                )}
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Ionicons
                  name={`notifications-outline`}
                  size={this.context.sizes.default}
                  style={{
                    alignSelf: "flex-end",
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                  onPress={() => alert("schedule a reminder")}
                />
                <FontAwesome
                  name={`sticky-note-o`}
                  size={this.context.sizes.default}
                  style={{
                    alignSelf: "flex-end",
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                  onPress={(e) =>
                    RootNavigation.push("Chapter", { id: chapter.id }, e)
                  }
                />
                <AntDesign
                  name={"up"}
                  size={this.context.sizes.default}
                  style={{
                    marginRight: this.context.sizes.base,
                    color: this.context.colors.foreground,
                  }}
                  onPress={() => this.setState({ expandScratchPad: false })}
                />
              </View>
            </View>
          )}
        </ScrollView>
        {!expandScratchPad && (
          <View
            style={{
              position: "absolute",
              top: 1.5,
              right: 0,
              padding: this.context.sizes.tiny,
            }}
          >
            <AntDesign
              name={"down"}
              size={this.context.sizes.default}
              style={{
                marginRight: this.context.sizes.base,
                marginLeft: ENV.WEB ? 0 : this.context.sizes.base,
                color: this.context.colors.trim,
              }}
              onPress={() => this.setState({ expandScratchPad: true })}
            />
          </View>
        )}
      </View>
    );
  };

  renderNodes = () => {
    let { chapter, loading, autoCreate, atemporal, isToday, details, selectedTarotMoment, prevChapterTarotMoment, prevChapterData } =
      this.state;
    // if (chapter?.id == 452) return null;
    const allMoments = chapter.moments || [];
    const firstTarotId = [...allMoments]
      .filter((m) => m.value?.category === "tarot")
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0]?.id;
    let moments = allMoments.filter(
      (m) => !(m.value?.category === "tarot" && m.id === firstTarotId),
    );

    let suggestions = [];
    let rolloverSuggestions = [];
    let isUpcoming = timeHelpers.isBefore(
      timeHelpers.beginningOfDay(),
      chapter.start_at,
    );
    if (chapter.current || chapter.id == "auto" || isUpcoming) {
      suggestions = (chapter.suggestions_from_above || []).map((v) => ({
        id: `${v.id}-suggestion`,
        value: v,
        suggestion: true,
      }));
      if (!suggestions.length) suggestions = this.props.suggestions || [];

      suggestions = suggestions.filter((s) => {
        let valueInChapter = allMoments.find((m) => m.value_id == s.value?.id);
        let valueChildInChapter = allMoments.find((m) =>
          s.value?.child_ids.includes(m.value_id),
        );
        const cat = s.value?.category;
        return !valueInChapter && !valueChildInChapter && cat !== "narration" && cat !== "tarot";
      });

      const inheritedValueIds = new Set(suggestions.map((s) => s.value?.id));
      rolloverSuggestions =
        chapter?.rollover_suggestions?.filter(
          (s) => !allMoments.find((m) => m.value_id == s.id) && !inheritedValueIds.has(s.id) && s.category !== "narration" && s.category !== "tarot",
        ) || [];
      rolloverSuggestions = rolloverSuggestions.map((s) => ({
        id: `${s.id}-rollover-suggestion`,
        value: s,
        suggestion: true,
      }));
    }

    if (details == "badges") {
      moments = [];
    }

    // filter completed moment parents
    // moments = moments.filter(
    //   (s) => !moments.find((m) => m.value_id == s.value?.id)
    // );

    // console.log(chapter.title, moments, suggestions);
    return (
      <View
        style={[
          this.styles().leftPadding,
          { paddingTop: this.context.sizes.base },
          { zIndex: 3 },
        ]}
      >
        {!!selectedTarotMoment && (
          <MomentBullet
            key={selectedTarotMoment.id}
            moment={selectedTarotMoment}
            chapter={chapter}
            rootChapter={chapter}
            chapterMoments={allMoments}
            onRefreshChapter={this.fetchChapter}
            onUpdateChapter={async (ch) => {
              this.setState({ chapter: ch, autoCreate: false });
              this.props.addSubChapter && this.props.addSubChapter(ch);
            }}
            expanded
            inputRef={(r) => (this.tarotBulletInputRef = r)}
            focusParentMoment={() => this.tarotBulletInputRef?.focus()}
            // escape from anywhere inside (scratchpad, moment row, nested
            // lists) also dismisses the tarot bullet
            onBrowseEscape={() => {
              this.setState({ selectedTarotMoment: null });
              this.fetchChapter();
            }}
            onEscape={() => {
              this.setState({ selectedTarotMoment: null });
              this.fetchChapter();
            }}
            onFocusChapterTitle={() => this.handleFocusTitle()}
            focusPrevious={() => {
              if (!!this.scratchPadRef) this.scratchPadRef.focus();
              else this.handleFocusTitle();
            }}
            focusNext={() => {
              this.momentList?.handleFocusFirstItem
                ? this.momentList.handleFocusFirstItem()
                : this.momentList?.handleFocusFirstMoment?.();
            }}
          />
        )}
        <MomentList
          ref={(ref) => (this.momentList = ref)}
          chapterId={chapter?.id}
          chapter={chapter}
          rootChapter={chapter}
          scopeToChapter={!atemporal}
          moments={moments}
          chapterMoments={details == "categories" ? [] : moments}
          nestPinnedChildren
          // taskRow={this.props.separateTasks == false ? false : true}
          // taskRow={false}
          taskRow={details == "tasks"}
          // hideScrathpadPreview={["titles", "tasks"].includes(details)}
          hideScrathpadPreview={details != "all"}
          values={chapter.values}
          // moments={[...moments, ...suggestions]}
          // moments={moments}
          suggestions={suggestions}
          showSuggestions={!this.state.hideSuggestionsFromAbove}
          rolloverSuggestions={
            this.state.hideRolloverSuggestions ? null : rolloverSuggestions
          }
          atemporal={atemporal}
          // expanded={chapter?.sub_chapters?.length == 0}
          // loading={loading}
          onUpdateMoment={(moment) => {
            let newMoments = chapter.moments.map((m) =>
              m.id == moment.id ? moment : m,
            );
            this.setState({ chapter: { ...chapter, moments: newMoments } });
          }}
          onUpdateMoments={(moments) => {
            console.log("on update moments", moments);
            this.setState({ chapter: { ...chapter, moments } });
          }}
          onUpdateChapter={async (chapter) => {
            this.setState({ chapter, autoCreate: false });
            this.props.addSubChapter && this.props.addSubChapter(chapter);
          }}
          onAddChild={(value) => {
            const ch = this.state.chapter;
            this.setState({
              chapter: {
                ...ch,
                moments: [
                  ...ch.moments,
                  { value_id: value.id, value, created_at: new Date().toISOString() },
                ],
              },
            });
          }}
          onRefreshChapter={this.fetchChapter}
          autoCreateChapter={autoCreate}
          chapterExpanded={this.state.expanded}
          onFocusMoment={(moment) => {
            if (moment === null && !this.props.zoomed) {
              this.props.onZoomIn && this.props.onZoomIn(this.state.chapter.id);
            }
          }}
          onExpandMoment={() => {
            if (!this.props.zoomed) {
              this.props.onZoomIn && this.props.onZoomIn(this.state.chapter.id);
            }
          }}
          onExpand={() => this.setState({ expanded: true })}
          onCollapse={() => {
            this.setState({ expanded: false });
            this.handleFocusTitle();
          }}
          // preventAutoFocus={this.state.preventAutoFocus}
          preventAutoFocus={this.props.preventAutoFocus}
          onFocusPreviousChapter={() => {
            if (this.props.zoomed) {
              this.props.onZoomOut && this.props.onZoomOut(this.state.chapter.id);
            }
            this.props.onFocusPreviousChapter &&
              this.props.onFocusPreviousChapter();
          }}
          onFocusNextChapter={() => {
            if (this.props.zoomed) {
              this.props.onZoomOut && this.props.onZoomOut(this.state.chapter.id);
            }
            this.props.onFocusNextChapter && this.props.onFocusNextChapter();
          }}
          onFocusChapterTitle={() => {
            this.handleFocusTitle();
          }}
          onMetaDown={() =>
            this.setState({ expandSuggestions: !expandSuggestions })
          }
          onFocusSubChapter={this.handleFocusSubChapter}
          onPinToParentChapter={this.handlePinToParentChapter}
          // Down-arrow from the composer focuses the tarot bullet beneath the list.
          focusTarotBelow={
            prevChapterTarotMoment ? () => this.prevTarotBulletRef?.focus() : undefined
          }
          isToday={isToday}
          parentChapter={this.props.parentChapter}
          scrollToChapter={() => {
            // this.props.scrollToChapter && this.props.scrollToChapter(chapter);
          }}
        />
        {!!prevChapterTarotMoment && (
          <MomentBullet
            key={`prev-tarot-${prevChapterTarotMoment.id}`}
            moment={prevChapterTarotMoment}
            chapter={prevChapterData}
            rootChapter={prevChapterData}
            chapterMoments={prevChapterData?.moments || []}
            inputRef={(r) => (this.prevTarotBulletRef = r)}
            onRefreshChapter={() => this.fetchPrevChapterTarot(chapter)}
          />
        )}
        {details == "badges" && this.renderBadges()}
      </View>
    );
  };

  cycleDetails = () => {
    let { details } = this.state;
    // let options = ["all", "titles", "categories", "tasks"]; //, "badges"];
    let options = ["titles", "all", "categories", "tasks"]; //, "badges"];
    let newDetails = options[options.indexOf(details) + 1];
    if (!newDetails) newDetails = options[0];
    this.setState({ details: newDetails });
  };

  handleFocusComposer = () => {
    if (!this.props.zoomed) {
      this.props.onZoomIn && this.props.onZoomIn(this.state.chapter.id);
    }
    !!this.momentList?.handleFocusComposer &&
      this.momentList.handleFocusComposer();
  };

  handleFocusFirstMoment = () => {
    !!this.momentList?.handleFocusFirstMoment &&
      this.momentList.handleFocusFirstMoment();
  };

  handleFocusTitle = () => {
    if (!this.props.zoomed) {
      this.props.onZoomIn && this.props.onZoomIn(this.state.chapter.id);
    }
    let ref = this[`ref-title`];
    if (!!ref) {
      this.justFocusedTitle = true;
      ref.focus();
    }
  };

  getHeaderButtonRefs = () => this.headerButtonRefs.filter(Boolean);

  handleExpandButtonKeyDown = (e) => {
    if (!ENV.WEB) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.toggleExpanded();
    } else if (e.key === 'Tab') {
      e.preventDefault();
      if (e.shiftKey) {
        this.tarotRef?.focus();
      } else {
        this[`ref-title`]?.focus();
      }
    }
  };

  handleHeaderButtonKeyDown = (e, slotIndex) => {
    if (!ENV.WEB) return;
    if (e.key !== 'Tab' && e.key !== 'Enter' && e.key !== ' ') return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.headerButtonRefs[slotIndex]?.click();
      return;
    }
    e.preventDefault();
    const refs = this.getHeaderButtonRefs();
    const currentRef = this.headerButtonRefs[slotIndex];
    const pos = refs.indexOf(currentRef);
    if (e.shiftKey) {
      if (pos <= 0) this[`ref-title`]?.focus();
      else refs[pos - 1]?.focus();
    } else {
      if (pos >= refs.length - 1) this[`ref-title`]?.focus();
      else refs[pos + 1]?.focus();
    }
  };

  handleFocusSubChapter = () => {
    console.log("focus subchap");
    let subChapters = chapterHelpers.subChapters(this.state.chapter);
    let ref;
    if (!subChapters?.length) {
      ref = this[`chapter-suggestedChapter`];
    } else {
      let currentSubChapterIndex = subChapters.findIndex((c) => c.current);
      if (currentSubChapterIndex < 0)
        currentSubChapterIndex = subChapters.length - 1;
      let subChapterId = subChapters[currentSubChapterIndex]?.id;
      ref = this[`chapter-${subChapterId}`];
    }
    if (ref) {
      !!ref.handleFocusTitle && ref.handleFocusTitle();
    }
  };

  handleFocusNextChapter = async (chapter, location = "composer") => {
    if (chapter.id == "suggestedChapter") return;
    let nextChapterId = null;
    let subChapters = chapterHelpers.subChapters(this.state.chapter);
    if (this.state.extraSubChapters?.length)
      subChapters = [...this.state.extraSubChapters, ...subChapters];
    let currentChapterIndex = subChapters.findIndex((c) => c.id == chapter.id);
    if (currentChapterIndex >= 0) {
      let nextChapterIndex = currentChapterIndex + 1;
      let nextChapter = subChapters[nextChapterIndex];
      let nextChapterId = nextChapter?.id || "suggestedChapter";
      // if (!!subChapters[nextChapterIndex]) {
      // let nextChapterId = subChapters[nextChapterIndex].id;
      let ref = this[`chapter-${nextChapterId}`];
      if (!!ref) {
        this.scrollToSubChapter(nextChapter);
        await this.setState({ preventNextScrollToSubChapter: true });
        await new Promise((r) => setTimeout(r, 400));

        if (location == "composer" && ref.state?.expanded)
          !!ref.handleFocusComposer && ref.handleFocusComposer();
        else if (location == "title" || !ref.state?.expanded)
          !!ref.handleFocusTitle && ref.handleFocusTitle();
      }
      // }
    }
  };

  handleFocusPreviousChapter = async (chapter, location = "composer") => {
    let nextChapterId = null;
    let subChapters = chapterHelpers.subChapters(this.state.chapter);
    if (this.state.extraSubChapters?.length)
      subChapters = [...this.state.extraSubChapters, ...subChapters];
    let currentChapterIndex = subChapters.findIndex((c) => c.id == chapter.id);
    if (chapter.id == "suggestedChapter") {
      currentChapterIndex = subChapters.length;
    }

    if (this.state.hideNonCurrent || !!this.state.hiddenIds?.length) {
      this.setState({ hiddenIds: [] });
      return;
    }

    if (currentChapterIndex >= 0) {
      let nextChapterIndex = currentChapterIndex - 1;
      if (!!subChapters[nextChapterIndex]) {
        let nextChapter = subChapters[nextChapterIndex];
        let nextChapterId = nextChapter.id;
        let ref = this[`chapter-${nextChapterId}`];
        if (!!ref) {
          this.scrollToSubChapter(nextChapter);
          await this.setState({ preventNextScrollToSubChapter: true });
          await new Promise((r) => setTimeout(r, 400));

          if (location == "composer" && ref.state?.expanded) {
            // if (location == "composer") {
            //   if (ref.state?.expanded)
            !!ref.handleFocusComposer && ref.handleFocusComposer();
            // else !!ref.toggleExpanded && ref.toggleExpanded();
            // }
          }
          // else if (location == "title")
          else if (location == "title" || !ref.state?.expanded)
            !!ref.handleFocusTitle && ref.handleFocusTitle();
        }
      }
    }
  };

  handlePinToParentChapter = async (value) => {
    let { chapter } = this.state;
    let { parentChapter } = this.props;
    if (parentChapter && chapter) {
      console.log(`pin ${value.id}:${value.title} to ${parentChapter.title}`);
      let res = await chapterActions.pinValue(parentChapter.id, value.id);
      console.log(res);
      // this.fetchChapter();
    } else {
      console.log("no parent chapter in props");
    }
  };

  renderSuggestionsFromBelow = () => {
    let { chapter, expandSuggestions, hideSuggestionsFromBelow, mountainView } =
      this.state;
    if (hideSuggestionsFromBelow) return null;
    let suggestions =
      !!chapter.suggestions_from_subchapters &&
      chapter.suggestions_from_subchapters.map((s) => ({
        id: `${s.id}-suggestion`,
        value: s,
        suggestion: true,
      }));

    const forceShowSuggestions = false;
    if (!!suggestions?.length) {
      return (
        <View
          style={[
            this.styles().leftPadding,
            {
              top: -this.context.sizes.small,
              zIndex: 1,
            },
          ]}
        >
          <TouchableOpacity
            onPress={() => this.setState({ expandSuggestions: !expandSuggestions })}
            style={{ alignSelf: "flex-start", paddingVertical: 2, cursor: "pointer" }}
          >
            <Ionicons
              name="arrow-redo-sharp"
              style={{ fontSize: this.context.sizes.smallItemHeight }}
              color={this.context.colors.trim}
            />
          </TouchableOpacity>
          {expandSuggestions && (
            <ScrollView
              horizontal
              nestedScrollEnabled
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{ flexDirection: "row", alignItems: "center" }}
            >
              {!forceShowSuggestions && (
                <BadgeRow
                  index={0}
                  collapsed
                  moments={suggestions.slice(0, 5)}
                  fade
                  wrapperStyle={{ zIndex: 3 }}
                  titleTooltip={"Propagated Suggestions"}
                  doublePressActions={["Pin", "Dismiss", "Snooze"]}
                  chapter={chapter}
                  rootChapter={chapter}
                  onUpdateChapter={async (chapter) => {
                    this.setState({ chapter, autoCreate: false });
                    this.props.addSubChapter && this.props.addSubChapter(chapter);
                  }}
                  onRefreshChapter={this.fetchChapter}
                  includeAttribution={"right"}
                />
              )}
            </ScrollView>
          )}
          {(expandSuggestions || forceShowSuggestions) && (
            <View
              style={
                {
                  // backgroundColor: this.context.colors.fill,
                  // opacity: 0.5,
                  // maxWidth: 600,
                }
              }
            >
              {/*suggestions.map((item, i) => {
                return (
                  <MomentBullet
                    key={`${i}-${item.id}`}
                    inputRef={(c) =>
                      (this[`ref-${i}-${item.id || item.value?.id}`] = c)
                    }
                    ref={(c) =>
                      (this[`bullet-ref-${i}-${item.id || item.value?.id}`] = c)
                    }
                    // wrapperStyle={{ backgroundColor: this.context.colors.fill }}
                    moment={item}
                    chapter={chapter}
                    rootChapter={chapter}
                    includeAttribution={"right"}
                    index={i}
                    shadeOnHover
                  />
                );
              })*/}
              <MomentList
                chapter={chapter}
                rootChapter={chapter}
                moments={suggestions}
                nestedChildrenView
                hideScrathpadPreview
                atemporal
                includeAttribution={"right"}
                onFocusChapterTitle={() => {
                  this.handleFocusTitle();
                }}
                onFocusSubChapter={() => alert("sub")}
              />
            </View>
          )}
          {mountainView && (
            <View style={this.styles().row}>
              {suggestions.map((item, i) => {
                let size = item.value.attribution_score * 15;
                return <Value key={i} value={item.value} size={size} />;
              })}
            </View>
          )}
        </View>
      );
    }
    return null;
  };

  renderRecents = () => {
    let { chapter, expandSuggestions, hideSuggestionsFromBelow, mountainView } =
      this.state;
    let recents =
      !!chapter.recents_from_subchapters &&
      chapter.recents_from_subchapters.map((s) => ({
        id: `${s.id}-suggestion`,
        value: s,
        suggestion: true,
      }));
    if (!!recents) {
      recents = recents?.filter((r) => !r.value?.completed_at);
      // try to find sub chapter that is today
      let todayChapter = chapterHelpers
        .subChapters(chapter)
        .find(
          (sc) =>
            timeHelpers.wasToday(sc.start_at) &&
            timeHelpers.wasToday(sc.end_at),
        );
      // console.log("TODAY", todayChapter);
      if (!!todayChapter) {
        // filter out if included in todayChapter.moments
        recents = recents?.filter((r) => {
          let valueInChapter = todayChapter.moments?.find(
            (m) => m.value_id == r.value?.id,
          );
          let valueChildInChapter = todayChapter.moments?.find((m) =>
            r.value?.child_ids.includes(m.value_id),
          );
          return !valueInChapter && !valueChildInChapter;
        });
      }
    }
    if (!!recents?.length) {
      return (
        <View
          style={[
            this.styles().leftPadding,
            { top: -12, paddingLeft: 18, zIndex: 1 },
          ]}
        >
          <TouchableOpacity
            onPress={() => this.setState({ expandSuggestions: !expandSuggestions })}
            style={{ alignSelf: "flex-start", paddingVertical: 2, cursor: "pointer" }}
          >
            <Ionicons
              name="arrow-redo-sharp"
              style={{ fontSize: this.context.sizes.smallItemHeight }}
              color={this.context.colors.trim}
            />
          </TouchableOpacity>
          {expandSuggestions && (
            <ScrollView
              horizontal
              nestedScrollEnabled
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{ flexDirection: "row", alignItems: "center" }}
            >
              <BadgeRow
                index={0}
                collapsed
                moments={recents}
                fade
                wrapperStyle={{ zIndex: 3 }}
                titleTooltip={"Recent Suggestions"}
                doublePressActions={["Pin", "Dismiss", "Snooze"]}
                chapter={chapter}
                rootChapter={chapter}
                onUpdateChapter={async (chapter) => {
                  this.setState({ chapter, autoCreate: false });
                  this.props.addSubChapter && this.props.addSubChapter(chapter);
                }}
                onRefreshChapter={this.fetchChapter}
                includeAttribution={"right"}
              />
            </ScrollView>
          )}
        </View>
      );
    }
    return null;
  };

  renderSubChapters = () => {
    let {
      chapter,
      loading,
      zoomedChapterIds,
      hiddenIds,
      level,
      expandedIds,
      preventSubChapterAutoFocus,
      composer,
      initialScrollComplete,
      chapterWidth,
      focusedChapterId,
      initialFetchComplete,
      fetching,
      scrolling,
      focusedSubChapterId,
      listView,
      fetchingExtraSubChapters,
      extraSubChapters,
    } = this.state;
    let { levelsDeep, onRootChapterLayout, handleRootChapterLayout } =
      this.props;
    // if (chapter?.id == 452) return null;
    let subChapters =
      this.props.subChapters || chapterHelpers.subChapters(chapter);
    if (!!extraSubChapters?.length)
      subChapters = [...extraSubChapters, ...subChapters];
    let hideNonCurrent = hiddenIds.includes("non_current");

    if (!subChapters?.length && loading) {
      // return null;
      // return <ActivityIndicator color={this.context.colors.foreground} />;
    }

    let includeTodaySuggestion = false;

    if (
      !loading &&
      ((chapter.id == "root" && !subChapters?.length) ||
        (chapter.current && chapter.range > 2)) &&
      !subChapters?.find((sc) => sc.current)
    ) {
      includeTodaySuggestion = true;
    }

    if (includeTodaySuggestion) {
      let yesterdayIndex = subChapters.findIndex((c) => {
        let startDate = timeHelpers.dateToDateTime(c.start_at);
        let isYesterday =
          timeHelpers.wasToday(startDate, timeHelpers.yesterday()) &&
          c.range == 1;
        if (isYesterday) return true;
        return false;
      });
      if (yesterdayIndex >= 0) {
        subChapters.splice(yesterdayIndex + 1, 0, { id: "auto" });
      } else {
        subChapters.push({ id: "auto" });
      }
    }

    // console.log(chapter.title, "subChapters", subChapters);

    let showMoreButton =
      subChapters?.length > 1 && (hideNonCurrent || !!hiddenIds?.length);
    let createNewButton =
      (!loading || initialFetchComplete) &&
      (chapter?.range > 1 || chapter?.id == "root") &&
      !composer &&
      (initialScrollComplete || this.props.subChaptersOnly);
    createNewButton = chapter?.range > 1 && !composer;

    let subChapterSuggestions =
      !!chapter.suggestions_for_subchapter &&
      chapter.suggestions_for_subchapter.map((s) => ({
        id: `${s.id}-suggestion`,
        value: s,
        suggestion: true,
      }));

    let initialScrollIndex = 0;
    if (!!subChapters.find((s) => s.current)) {
      initialScrollIndex = subChapters.indexOf((s) => s.current);
    }
    if (!!showMoreButton) initialScrollIndex += 1;
    return (
      <ScrollView
        horizontal={!listView}
        nestedScrollEnabled
        // refreshControl={
        //   <RefreshControl
        //     refreshing={false}
        //     onRefresh={() => alert("refresh")}
        //     colors={[this.context.colors.foreground]}
        //     tintColor={this.context.colors.foreground}
        //     progressBackgroundColor={this.context.colors.fill}
        //   />
        // }
        pagingEnabled={!ENV.WEB}
        initialPage={initialScrollIndex}
        keyboardShouldPersistTaps={"always"}
        // scrollEnabled={!this.state.disableScroll}
        style={[
          this.styles().subChaptersWrapper,
          this.props.subChaptersOnly && this.styles().rootSubChaptersWrapper,
          this.styles().topMargin,
          this.styles().bottomMargin,
          // this.styles().leftPadding,
          !ENV.WEB && { maxWidth: chapterWidth },
        ]}
        contentContainerStyle={[
          this.styles().subChaptersContainer,
          listView && this.styles().subChaptersContainerList,
        ]}
        // contentOffset={{ x: (subChapters.length - 1) * CHAPTER_WIDTH }}
        ref={(ref) => (this.subChapters = ref)}
        onLayout={(e) => {}}
        scrollEventThrottle={100}
        onScroll={(event) => {
          if (DISABLE_DRAGGING) return;
          let lastUpdatedAt = store.getState().dragging.layoutUpdatedAt;
          let layoutUpdatedAt = new Date().getTime();
          // if(!lastUpdatedAt || layoutUpdatedAt - lastUpdatedAt > 500){
          store.dispatch({
            type: "dragging/set_layout_updated_at",
            layoutUpdatedAt,
          });
          // let scrollPos = Math.round(event.nativeEvent.contentOffset.x);
          // if (Math.round(scrollPos % chapterWidth) == 0) haptics.light();
          // else if (scrollPos < 0) {
          //   if (!this.state.overScrollBump) {
          //     haptics.error();
          //     this.setState({ overScrollBump: true });
          //   }
          // } else if (scrollPos < this.state.scrollWidth) {
          //   if (!this.state.overScrollBump) {
          //     haptics.error();
          //     this.setState({ overScrollBump: true });
          //   }
          // } else if (this.state.overScrollBump) {
          //   this.setState({ overScrollBump: false });
          // }
        }}
        onScrollBeginDrag={() => this.setState({ scrolling: true })}
        // onScrollEndDrag={() => this.setState({scrolling: false})}
        onMomentumScrollEnd={() => {
          this.setState({ scrolling: false });
        }}
      >
        {(!chapter?.range || chapter?.range > 1) && (
          <View
            style={
              ENV.WEB
                ? {
                    minWidth: 40,
                    marginRight: this.context.sizes.large,
                    borderRadius: this.context.sizes.borderRadius,
                  }
                : {
                    borderRadius: 0,
                    width: chapterWidth,
                    marginRight: 0,
                    // padding:
                    //   this.context.sizes.base *
                    //   this.context.sizes.mobileIncrease,
                    justifyContent: "center",
                  }
            }
          >
            {fetchingExtraSubChapters || (false && !initialScrollComplete) ? (
              <ActivityIndicator />
            ) : (
              <Text
                button
                disabled={fetchingExtraSubChapters}
                onPress={async () => {
                  await this.setState({ fetchingExtraSubChapters: true });
                  let res = await chapterActions.getPreviousChapter(
                    subChapters[0].id,
                  );
                  this.setState({ fetchingExtraSubChapters: false });
                  if (res?.chapter) {
                    await this.setState({
                      extraSubChapters: [res.chapter, ...extraSubChapters],
                    });
                  }
                }}
                // this.setState({ hiddenIds: [], zoomedChapterIds: [] })
                style={
                  ENV.WEB
                    ? {
                        // minWidth: 40,
                        // marginRight: this.context.sizes.large,
                        // borderRadius: this.context.sizes.borderRadius,
                      }
                    : {
                        borderRadius: 0,
                        width: chapterWidth,
                        marginRight: 0,
                        padding:
                          this.context.sizes.base *
                          this.context.sizes.mobileIncrease,
                      }
                }
                numberOfLines={1}
                center
              >
                {"<"}
              </Text>
            )}
          </View>
        )}

        {showMoreButton && (
          <Text
            button
            onPress={() => this.setState({ hiddenIds: [] })}
            // this.setState({ hiddenIds: [], zoomedChapterIds: [] })
            style={
              ENV.WEB
                ? {
                    width: ENV.WEB
                      ? undefined
                      : chapterWidth - this.context.sizes.large,
                    minWidth: 40,
                    marginRight: this.context.sizes.large,
                    borderRadius: this.context.sizes.borderRadius,
                  }
                : {
                    borderRadius: 0,
                    width: chapterWidth,
                    marginRight: 0,
                    padding:
                      this.context.sizes.base *
                      this.context.sizes.mobileIncrease,
                  }
            }
            numberOfLines={1}
            center
            // Show More
          >
            ...
          </Text>
        )}

        {subChapters.map((subChapter, i) => {
          if (
            !!subChapter.dismissed_suggestions?.length &&
            !!subChapterSuggestions?.length
          ) {
            subChapterSuggestions = subChapterSuggestions?.filter(
              (s) => !subChapter.dismissed_suggestions.includes(s.value.id),
            );
          }
          //if (subChapter.range == 1 && i == subChapters.length - 1) {
          if (subChapter.id == "auto") {
            return this.renderTodayChapterSuggestion(subChapterSuggestions);
          }
          let zoomed = zoomedChapterIds.includes(subChapter.id);
          let hidden =
            hiddenIds.includes(subChapter.id) ||
            (hideNonCurrent && !subChapter.current);
          // if (!!zoomedChapterId && !zoomed) return null;
          if (hidden) return null;

          let wingColors = {};
          //if (!this.state.scrolling) {
          if (!ENV.WEB) {
            let prevChap = subChapters[i - 1];
            let prevChapColor = !!prevChap?.id
              ? chapterHelpers.getColor(
                  prevChap,
                  this.context.colors,
                  this.context.colorScheme,
                )
              : showMoreButton
                ? this.context.colors.fill
                : null;
            let nextChap = subChapters[i + 1];
            let nextChapColor = !!nextChap?.id
              ? chapterHelpers.getColor(
                  nextChap,
                  this.context.colors,
                  this.context.colorScheme,
                )
              : createNewButton
                ? this.context.colors.fill
                : null;
            wingColors = { left: prevChapColor, right: nextChapColor };
          }

          // focusedSubChapterId == chapter.id && { zIndex: 2},
          return (
            <Hoverable key={i}>
              {(isHovered) => (
                <RecursiveChapter
                  // ref={(ref) => (this[`chapter-${subChapter.id}`] = ref)}
                  rootScrollerRef={this.props.rootScrollerRef}
                  handleRootChapterLayout={onRootChapterLayout}
                  onRootChapterLayout={onRootChapterLayout}
                  // onRootChapterLayout={
                  //   levelsDeep == 2 ? onRootChapterLayout : null
                  // }
                  // onLayout={
                  //   !handleRootChapterLayout
                  //     ? undefined
                  //     : () => {
                  //         const ref = this[`chapter-${subChapter.id}`];
                  //         console.warn(
                  //           "recursive layout complete",
                  //           ref.wrapperRef?.measure
                  //         );
                  //         if (!!ref?.wrapperRef?.measure) {
                  //           ref.wrapperRef.measure(
                  //             // this.props.rootScrollerRef,
                  //             (x, y, width, height, pageX, pageY) => {
                  //               console.warn("onRootChapterLayout", pageY);
                  //               handleRootChapterLayout(pageY);
                  //             }
                  //           );
                  //         } else {
                  //           handleRootChapterLayout(25);
                  //         }
                  //       }
                  // }
                  wingColors={wingColors}
                  lastFetchedAt={this.props.lastFetchedAt}
                  levelsDeep={levelsDeep + 1}
                  focusedChapterId={focusedChapterId}
                  passthruRef={(ref) =>
                    (this[`chapter-${subChapter.id}`] = ref)
                  }
                  scrollPageTo={this.props.scrollPageTo}
                  titleRef={(ref) =>
                    (this[`chapter-${subChapter.id}-title`] = ref)
                  }
                  navigation={this.props.navigation}
                  route={this.props.route}
                  key={i}
                  parentChapter={chapter}
                  chapter={subChapter}
                  scrollToChapter={() => this.scrollToSubChapter(subChapter)}
                  focusChapter={(id) => this.setState({ focusedChapterId: id })}
                  unfocusChapter={() =>
                    this.setState({ focusedChapterId: null })
                  }
                  // suggestions={
                  //   !!chapter?.moments &&
                  //   chapter.moments
                  //     // .filter(
                  //     //   (v) =>
                  //     //     !v.completed_at &&
                  //     //     !chapter?.moments?.find(
                  //     //       (m) => m.value_id == v.id && !!m.completed_at
                  //     //     )
                  //     // )
                  //     .map((m) => ({
                  //       id: `${m.value.id}-suggestion`,
                  //       value: { ...m.value, suggestion: true },
                  //       suggestion: true,
                  //     }))
                  // }
                  suggestions={subChapterSuggestions}
                  hasSiblings={subChapters.length > 1}
                  zoomed={zoomed}
                  // expanded={level < 3 && subChapter.current}
                  expanded={
                    (chapter.current && subChapter.current) ||
                    expandedIds.includes(subChapter.id)
                  }
                  preventAutoFocus={preventSubChapterAutoFocus}
                  level={level + 1}
                  onZoomOut={this.handleZoomOut}
                  onZoomIn={this.handleZoomIn}
                  onHide={() => {
                    this.setState({ hiddenIds: [...hiddenIds, subChapter.id] });
                  }}
                  expandSiblings={async () => {
                    // to actually expand siblings, uncomment the preventSubChapterAutoFocus and expandedIds lines
                    await this.setState({ preventSubChapterAutoFocus: true });
                    await this.setState({
                      // zoomedChapterId: null,
                      hiddenIds: [],
                      expandedIds: subChapters.map((c) => c.id),
                      initialScrollComplete: false,
                    });
                    await this.setState({ preventSubChapterAutoFocus: false });
                    // this.scrollToCurrent(false);
                  }}
                  onExpand={() => {
                    this.setState({
                      expandedIds: [...expandedIds, subChapter.id],
                    });
                  }}
                  onCollapse={() => {
                    this.setState({
                      expandedIds: expandedIds.filter(
                        (id) => id != subChapter.id,
                      ),
                    });
                  }}
                  onFocusPreviousChapter={(location) =>
                    this.handleFocusPreviousChapter(subChapter, location)
                  }
                  onFocusNextChapter={(location) =>
                    this.handleFocusNextChapter(subChapter, location)
                  }
                  onFocusParentComposer={this.handleFocusComposer}
                  onFocusParentTitle={this.handleFocusTitle}
                  onRollover={this.handleRollover}
                  addSubChapter={this.addSubChapter}
                  style={{
                    //   subChapter.current && { flex: 2, minWidth: CHAPTER_WIDTH * 2 }
                    // zIndex: isHovered ? 2 : undefined,
                    zIndex: 999 - i,
                    zIndex: i,
                  }}
                  refreshParentChapter={this.fetchChapter}
                  onFinishLoading={() => {
                    this.handleSubChapLayoutFinished();
                  }}
                />
              )}
            </Hoverable>
          );
        })}

        {/* create new chapter */}
        {createNewButton && (
          <RecursiveChapter
            key={this.state.newChapterId}
            levelsDeep={levelsDeep + 1}
            chapter={{
              title: chapterHelpers.nextTitle(subChapters),
              start_at: chapterHelpers.nextStartAt(subChapters),
              end_at: chapterHelpers.nextEndAt(subChapters),
              range: chapterHelpers.nextRange(subChapters),
              current: false,
              id: "auto",
            }}
            collapsedStyle={{
              maxWidth: ENV.WEB ? 30 : undefined,
              minWidth: ENV.WEB ? 30 : undefined,
              backgroundColor: "transparent",
              borderWidth: 0,
            }}
            composer
            autoCreate
            addSubChapter={(c) => {
              this.setState({
                newChapterId: (this.state.newChapterId || 0) + 1,
              });
              this.addSubChapter(c);
            }}
            parentChapter={chapter.id == "root" ? null : chapter}
            // expanded
          />
        )}

        {/* composer for next chapter */}
        {/*!zoomedChapterIds?.length &&
          !!subChapters.length &&
          !subChapters?.find((sc) => chapterHelpers.atemporal(sc)) && (
            <RecursiveChapter
              chapter={{
                title: chapter.range <= 7 ? timeHelpers.getDayOfWeek() : "",
                start_at: timeHelpers.dateTimeToDate(
                  chapter.range <= 7
                    ? undefined
                    : timeHelpers.beginningOfMonth(null, 1)
                ),
                end_at: timeHelpers.dateTimeToDate(
                  chapter.range <= 7
                    ? undefined
                    : timeHelpers.endOfMonth(null, 1)
                ),
              }}
              chapter={chapterHelpers.suggestedSubChapter(
                chapter,
                subChapters[subChapters.length - 1]
              )}
              collapsedStyle={
                ENV.WEB
                  ? { maxWidth: 100, minWidth: 100 }
                  : {
                      maxWidth: CHAPTER_WIDTH,
                      minWidth: CHAPTER_WIDTH,
                    }
              }
              composer
            />
          )*/}
        {this.renderMissingChapters(chapter, subChapters)}
        <View style={this.styles().scrollOverflowHack} />
        {/*</View>
        </TouchableWithoutFeedback>*/}
      </ScrollView>
    );
  };

  handleSubChapLayoutFinished = (e = null) => {
    // this.subChapters?.scrollToEnd({ animated: false });
    // return;
    if (!!this.subChapters) {
      this.subChapters?.measure((x, y, width, height) => {
        this.setState({ scrollWidth: width });
        // if (!!onRootChapterLayout) {
        //   console.warn("onRootChapterLayout", height);
        //   onRootChapterLayout(height);
        // }
        this.scrollToCurrent(true);
      });
    } else {
      this.scrollToCurrent(true);
    }
  };

  renderTodayChapterSuggestion = (subChapterSuggestions = []) => {
    let { loading, chapter } = this.state;
    let { levelsDeep } = this.props;
    return (
      <RecursiveChapter
        key={"auto"}
        passthruRef={(ref) => (this[`chapter-suggestedChapter`] = ref)}
        titleRef={(ref) => (this[`chapter-suggestedChapter-title`] = ref)}
        levelsDeep={levelsDeep + 1}
        chapter={{
          // title: "WHAT",
          start_at: timeHelpers.dateTimeToDate(),
          end_at: timeHelpers.dateTimeToDate(),
          range: 1,
          current: true,
          id: "auto",
        }}
        // collapsedStyle={{ maxWidth: 100, minWidth: 100 }}
        // composer
        autoCreate
        parentChapter={chapter}
        expanded
        addSubChapter={this.addSubChapter}
        onFocusPreviousChapter={(location) =>
          this.handleFocusPreviousChapter({ id: "suggestedChapter" }, location)
        }
        onFocusNextChapter={(location) =>
          this.handleFocusNextChapter({ id: "suggestedChapter" }, location)
        }
        onFocusParentComposer={this.handleFocusComposer}
        onFocusParentTitle={this.handleFocusTitle}
        suggestions={subChapterSuggestions}
        refreshParentChapter={this.fetchChapter}
      />
    );
  };

  addSubChapter = (subChapter) => {
    // console.log("this.addSubChapter, but redux should handle this");
    // return;
    let { chapter } = this.state;
    console.log(chapter);
    if (!chapter.sub_chapter_ids) return;
    this.setState({
      chapter: {
        ...chapter,
        // sub_chapters: [...chapter.sub_chapters, sc],
        sub_chapter_ids: [...chapter.sub_chapter_ids, subChapter.id],
      },
    });
  };

  renderMissingChapters = (chapter, subChapters) => {
    return null;
    let { chapterWidth } = this.state;
    if (this.state.loading || chapter.range == 1) return;
    // create a placeholder autocreate chapter for each step of the parent chapter

    // chapterHelpers

    let subRange = chapterHelpers.guessSubRange(chapter);
    if (!!subChapters.length) {
      // subRange = subChapters[subChapters.length-1].range
    }
    let missingDays = chapter.range - subChapters.length * subRange;
    let missingChunks = Math.round(missingDays / subRange);

    let suggestions = [];
    for (let i = 0; i < missingChunks; i++) {
      let prevChapter = !!suggestions.length
        ? suggestions[suggestions.length - 1]
        : subChapters[subChapters.length - 1];
      let ch = chapterHelpers.suggestedSubChapter(chapter, prevChapter);
      // console.log("prev chapter", prevChapter, ch);
      suggestions.push(ch);
    }

    return suggestions.map((ch) => {
      return (
        <RecursiveChapter
          chapter={ch}
          collapsedStyle={
            ENV.WEB
              ? { maxWidth: 100, minWidth: 100 }
              : {
                  maxWidth: chapterWidth,
                  minWidth: chapterWidth,
                }
          }
          composer
          autoCreate
        />
      );
    });

    {
      !zoomedChapterIds?.length &&
        !!subChapters.length &&
        !subChapters?.find((sc) => chapterHelpers.atemporal(sc)) && (
          <RecursiveChapter
            chapter={{
              title: chapter.range <= 7 ? timeHelpers.getDayOfWeek() : "",
              start_at: timeHelpers.dateTimeToDate(
                chapter.range <= 7
                  ? undefined
                  : timeHelpers.beginningOfMonth(null, 1),
              ),
              end_at: timeHelpers.dateTimeToDate(
                chapter.range <= 7
                  ? undefined
                  : timeHelpers.endOfMonth(null, 1),
              ),
            }}
            chapter={chapterHelpers.suggestedSubChapter(
              chapter,
              subChapters[subChapters.length - 1],
            )}
            collapsedStyle={
              ENV.WEB
                ? { maxWidth: 100, minWidth: 100 }
                : {
                    maxWidth: chapterWidth,
                    minWidth: chapterWidth,
                  }
            }
            composer
          />
        );
    }
  };

  handleHide = () => {
    !!this.props.onHide && this.props.onHide();
  };

  scrollToCurrent = async (animated = true, retriesLeft = 3) => {
    // if (!ENV.WEB) return;
    if (this.state.initialScrollComplete) {
      return;
    }
    console.log(
      "scroll to current",
      this.state.chapter?.start_at,
      this.state.chapter?.range,
    );
    // this.setState({ initialScrollComplete: true });
    let { chapter, chapterWidth } = this.state;
    if (!this.subChapters) {
      console.log("no scroll ref...");
      if (retriesLeft >= 0) {
        setTimeout(() => {
          this.scrollToCurrent(animated, retriesLeft - 1);
        }, 300);
      } else {
        this.setState({ initialScrollComplete: true });
        console.warn(
          "no more retries, no scrollToCurrent ref found for",
          this.state.chapter?.id,
        );
      }
      return;
    }

    let subChapters = chapterHelpers.subChapters(chapter);
    let currentIndex = subChapters.findIndex((sc) => sc.current);
    // console.log("LAYOUT", currentIndex, chapter);
    console.warn(this.state.chapter?.id, subChapters);
    if (currentIndex >= 0) {
      currentIndex += 1; // accound for the "show prev chapter" button
      console.log(
        this.state.chapter?.title,
        `initial scroll to ${currentIndex - 1}`,
        subChapters[currentIndex - 1].start_at,
      );
      this.subChapters.scrollTo({
        x: chapterWidth * currentIndex,
        // x: 9999,
        animated,
      });
      await this.setState({ initialScrollComplete: true });
    } else {
      console.log(
        this.state.chapter?.title || this.state.chapter?.id,
        "initial scroll to END",
      );
      // console.warn(this.state.chapter?.id, subChapters);
      // console.warn(subChapters.count);
      this.subChapters.scrollTo({
        x: 9999,
        animated,
      });
      this.setState({ initialScrollComplete: true });
    }
    if (this.state.chapter?.range == 1) {
      await new Promise((r) => setTimeout(r, 500));
      if (!ENV.WEB) {
        if (!this.props.scrollPageTo)
          console.warn("no this.props.scrollPageTo");
        let offset = 9999;
        if (this.wrapperRef) {
          this.wrapperRef?.measure((x, y, width, height, pageX, pageY) => {
            // console.error("scroll to wrapper ref!", pageY, y);
            this.props.scrollPageTo &&
              // this.props.scrollPageTo(pageY - 64 - this.context.sizes.large);
              this.props.scrollPageTo(pageY);
          });
        } else {
          this.props.scrollPageTo && this.props.scrollPageTo(offset);
        }
      }
    }
  };

  scrollToSubChapter = async (subChapter) => {
    // return;
    // if (!ENV.WEB) return;
    if (!subChapter?.id) return;
    if (this.state.preventNextScrollToSubChapter) {
      console.log("additonal scrolltosubchapter prevented");
      this.setState({ preventNextScrollToSubChapter: false });
      return;
    }
    // await this.setState({ disableScroll: false });
    // return;
    console.log("scroll to subchapter", subChapter?.id);
    // if (this.state.initialScrollComplete) return;
    let { chapter, chapterWidth } = this.state;
    if (!this.subChapters) {
      console.log("no scroll ref...");
      return;
    }
    this.setState({ focusedChapterId: subChapter.id });
    let subChapters = chapterHelpers.subChapters(chapter);
    let targetIndex = subChapters.findIndex((sc) => sc.id == subChapter.id);
    if (targetIndex >= 0) {
      // console.log(
      //   "----------------scrolling to subchap: ",
      //   subChapter.title,
      //   targetIndex
      // );
      this.subChapters.scrollTo({
        x: chapterWidth * targetIndex,
        animated: true,
      });
    } else {
      console.log(
        "no subchap target found: ",
        subChapter,
        subChapters,
        targetIndex,
      );
    }
  };

  handleRollover = async (subChapterId) => {
    let { chapter } = this.state;
    let res = await chapterActions.rollover(subChapterId, chapter.id);
    if (res?.success) {
    } else if (res?.error) {
      alert(res.error);
    }
  };

  styles = () => ({
    wrapper: {
      flex: 1,
      marginRight: ENV.WEB ? this.context.sizes.large : 0,
      marginBottom: this.context.sizes.large,
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minHeigh: this.context.sizes.HEIGHT / 4,
    },
    listViewWrapper: {
      minHeight: null,
      alignSelf: "stretch",
    },
    rootChapterWrapper: {
      // backgroundColor: this.context.colors.fill,
      borderWidth: 0,
      marginRight: 0,
      paddingRight: ENV.WEB ? this.context.sizes.large : 0,
    },
    rootSubChaptersWrapper: {
      paddingLeft: 0,
    },
    todayWrapper: {
      borderColor: this.context.colors.foreground,
      borderWidth: 2,
      // borderRadius: this.context.sizes.borderRadius,
    },
    innerWrapper: {
      borderRadius: ENV.WEB ? this.context.sizes.borderRadius : 0,
      borderWidth: ENV.WEB ? 1 : 0,
      borderColor: this.context.colors.trim,
      flex: 1,
      // justifyContent: "flex-start",
      // alignItems: "flex-start",
      width: "100%",
      // backgroundColor: this.context.colors.empty,
    },
    header: {
      alignSelf: "stretch",
      // borderWidth: 1,
      // borderTopWidth: 0,
      // borderBottomWidth: 1,
      borderColor: this.context.colors.trim,
      backgroundColor: this.context.colors.fill,
      padding: this.context.sizes.base * this.context.sizes.mobileIncrease,
      paddingHorizontal:
        this.context.sizes.large * this.context.sizes.mobileIncrease,
    },
    expandedHeader: {
      backgroundColor: this.context.colors.trim,
    },
    title: {
      // flex: 1,
      borderColor: this.context.colors.foreground,
      marginRight: this.context.sizes.base,
      // marginRight: ENV.WEB ? this.context.sizes.base : 0,
      maxWidth: "100%",
      // color: this.context.colors.lightForeground,
      lineHeight: this.context.sizes.large,
    },
    body: {
      // alignItems: 'flex-start',
      flex: 1,
      alignSelf: "stretch",
      zIndex: 99,
    },
    topMargin: {
      // marginTop: this.context.sizes.base,
    },
    bottomMargin: {
      // marginBottom: this.context.sizes.base,
    },
    leftPadding: {
      paddingLeft: this.context.sizes.base,
    },
    row: {
      // padding: this.context.sizes.base,
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      // width: 400,
    },
    suggestionsRow: {
      // marginHorizontal: this.context.sizes.base,
      // backgroundColor: colorHelpers.hexToRgbaString(this.context.colors.trim, 0.5),
      borderRadius: this.context.sizes.large,
      // borderWidth: 1,
    },
    nodesCol: {
      // marginTop: this.context.sizes.base,
      paddingLeft: this.context.sizes.base,
    },
    subChaptersWrapper: {
      flex: ENV.WEB ? 1 : 0,
      // overflow: "visible",
      // ...(ENV.WEB
      //   ? {
      //       overflowY: "visible",
      //     }
      //   : { overflow: "hidden" }),
    },
    subChaptersContainer: {
      flex: ENV.WEB ? 1 : 0,
      paddingLeft: ENV.WEB ? this.context.sizes.large : 0,
      flexDirection: "row",
      alignItems: "flex-start",
    },
    subChaptersContainerList: {
      flexDirection: "column",
    },
    loadingWrapper: {
      // alignItems: 'center',
      // flex: 1,
    },
    scrollOverflowHack: {
      // this allow contentContainerStyle to flex (so it stays within parent)
      // without the final child of ScrollView's marginRight being ignored
      borderColor: this.context.colors.empty,
      borderWidth: 1,
      marginLeft: -2,
    },
    formWrapper: {
      alignItems: "flex-start",
      // alignItems: "center",
      padding: this.context.sizes.large,
      paddingTop: 0,
    },
    formRow: {
      flexDirection: "row",
      marginTop: this.context.sizes.large,
    },
    headerButton: {
      fontSize: ENV.WEB ? this.context.sizes.default : this.context.sizes.large,
    },
  });
}
